import { ShieldCheck, DollarSign, Gauge, Target, Percent } from "lucide-react";
import { LRDirectComingSoonToolCard } from "./LRDirectAtlasCard";

/** LR Direct Rate Guard — visual placeholder (no LR Direct logic yet). */
export default function LRDirectRateGuardCard() {
  return (
    <LRDirectComingSoonToolCard
      icon={ShieldCheck}
      title="ATLAS Rate Guard"
      bannerIcon={DollarSign}
      bannerText="Sanity-check bids before you award"
      bannerTone="teal"
      description="ATLAS will flag direct bids that sit far above or below your lane baseline so you never award a bad number by accident."
      stats={[
        { label: "Guarded", value: "--", icon: Gauge },
        { label: "Flagged", value: "--", icon: Target },
        { label: "Variance", value: "--", icon: Percent },
      ]}
      listTitle="Guard checks"
      rows={[
        { label: "Bid vs lane baseline", value: "soon" },
        { label: "Bid vs award history", value: "soon" },
        { label: "Outlier detection", value: "soon" },
      ]}
      ctaLabel="Run Rate Guard"
    />
  );
}
